import { useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { TagIcon as Tag, TruckIcon as Truck } from "@phosphor-icons/react";
import { EditableList } from "@/components/CrmConfig";

// Sezione impostazioni: gestione elenchi che popolano i menu a tendina della pagina Servizi
// ("Tutte le tipologie" e "Tutti i fornitori").
export function ServiziConfigSection() {
  const [cfg, setCfg] = useState(null);
  const load = useCallback(() => api.get("/crm-config")
    .then(({ data }) => setCfg({ tipologie_servizi: data.tipologie_servizi || [], fornitori_servizi: data.fornitori_servizi || [] }))
    .catch(() => setCfg({ tipologie_servizi: [], fornitori_servizi: [] })), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    try { await api.put("/crm-config", cfg); toast.success("Elenchi Servizi salvati"); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Errore"); }
  };
  if (!cfg) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  return (
    <Card className="rounded-sm shadow-none p-4 space-y-5" data-testid="servizi-config-section">
      <div>
        <h3 className="font-heading text-base font-semibold">Servizi — Tipologie & Fornitori</h3>
        <p className="text-[11px] text-muted-foreground mt-0.5">Questi elenchi popolano i menu a tendina "Tutte le tipologie" e "Tutti i fornitori" nella pagina Servizi, oltre ai campi Tipo e Fornitore nella scheda servizio.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <EditableList title="Tipologie" icon={<Tag size={16} className="text-primary" />} items={cfg.tipologie_servizi} onChange={(v) => setCfg((c) => ({ ...c, tipologie_servizi: [...v].sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" })) }))} placeholder="es. PEC, Dominio, SSL Wildcard" testidPrefix="srv-tipo" />
        <EditableList title="Fornitori" icon={<Truck size={16} className="text-primary" />} items={cfg.fornitori_servizi} onChange={(v) => setCfg((c) => ({ ...c, fornitori_servizi: [...v].sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" })) }))} placeholder="es. Aruba, Zyxel Nebula, Sophos" testidPrefix="srv-forn" />
      </div>
      <div className="flex justify-end"><Button className="rounded-sm" onClick={save} data-testid="servizi-config-save">Salva elenchi</Button></div>
    </Card>
  );
}
